import { AlertCircle } from 'lucide-react';

import type { ApiError } from '@/lib/errors';

export function ErrorState({ error }: { error: ApiError }): JSX.Element {
  return (
    <div
      className="flex items-start gap-3 rounded-xl border border-accent-crimson/25 bg-accent-crimson/[0.06] p-4"
      role="alert"
    >
      <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-accent-crimson/15 text-accent-crimson">
        <AlertCircle className="h-4 w-4" />
      </div>
      <div className="min-w-0">
        <p className="text-sm font-semibold text-accent-crimson">{error.message}</p>
        <p className="mt-1 font-mono text-[11px] tracking-wider text-accent-crimson/80">
          {error.code}
          {error.requestId && <> · request {error.requestId}</>}
        </p>
      </div>
    </div>
  );
}
